import styled from "styled-components";

export const StyledErrorModalContent = styled.div`
  text-align: center;
  word-break: break-word;
  overflow-wrap: break-word;
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
  color: #333333;
`;

export const StyledError = styled.div`
  width: 86px;
  height: 86px;
  display: block;
  margin: auto;
`;

export const StyledButtons = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledButton = styled.div`
  flex-grow: 1;
  padding: 0px 10px;
`;
